/**
 * Map and merge ticket API messages with inbox session messages.
 */

export class TicketThreadMerger {
  /**
   * @param {Record<string, unknown>} row
   */
  mapTicketMessage(row) {
    const senderType = String(row?.sender_type || "").toLowerCase();
    const sender = senderType === "customer" ? "user" : "agent";
    const text = String(row?.body_text || row?.body_html || "").trim() || "[Attachment]";
    const created = row?.created_at;
    const sentAt = created ? new Date(created).toISOString() : new Date().toISOString();
    const time = created
      ? new Date(created).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      : "";
    return {
      id: `tm-${row?.id ?? Math.random()}`,
      sender,
      text,
      time,
      type: "text",
      sentAt,
      attachments: Array.isArray(row?.attachments) ? row.attachments : [],
    };
  }

  /**
   * @param {Array<Record<string, unknown>>} ticketRows
   * @param {Array<{ id: string, sentAt?: string }>} inboxRows
   */
  mergeWithInboxMessages(ticketRows, inboxRows) {
    const ticketMsgs = ticketRows.map((r) => this.mapTicketMessage(r));
    if (!ticketMsgs.length) return [...inboxRows];
    const seen = new Set(ticketMsgs.map((m) => m.id));
    const merged = [...ticketMsgs];
    for (const m of inboxRows) {
      if (!seen.has(m.id)) merged.push(m);
    }
    merged.sort((a, b) => {
      const ta = Date.parse(a.sentAt || "") || 0;
      const tb = Date.parse(b.sentAt || "") || 0;
      return ta - tb;
    });
    return merged;
  }
}

export const ticketThreadMerger = new TicketThreadMerger();
